var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{attrs:{"STYLE":"PADDING:20PX"}},[_vm._v("EL PERFIL PÚBLICO SE MOSTRARÁ ACÁ")])])
}]

export { render, staticRenderFns }